export default __webpack_public_path__ + "static/media/oscer-pres-pale-stools.e005a5ed.svg";